export default __webpack_public_path__ + "static/media/joker_card_anim.05bf84b0.gif";